import { useStripe, useElements, PaymentElement } from "@stripe/react-stripe-js";
import { useState, FormEvent } from "react";
import { usePlanAddPaymentMethod } from "@/hooks/plans/use-plan-add-payment-method";
import { useUserConfig } from "@/hooks/user/use-user-config";

interface PaymentMethodFormProps {
  subscriptionId: string; // Passed from backend
}

export function StripePayment({ subscriptionId }: PaymentMethodFormProps) {
  const stripe = useStripe();
  const elements = useElements();
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const addPaymentMethod = usePlanAddPaymentMethod();
  const { data, refetch } = useUserConfig();

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!stripe || !elements) return;

    setLoading(true);
    setError(null);

    // Create a new payment method
    const { error, setupIntent } = await stripe.confirmSetup({
      elements,
      confirmParams: {
        return_url: window.location.href,
      },
      redirect: 'if_required'
    });

    if (error) {
      setError(error.message);
      setLoading(false);
      return;
    }

    await addPaymentMethod.mutateAsync({
      paymentMethodId: setupIntent.payment_method,
      subscriptionId,
    });

    refetch();
  };

  return (
    <form onSubmit={handleSubmit}>
      <PaymentElement />
      <button type="submit" disabled={!stripe || loading}>
        {loading ? "Updating..." : "Update Payment Method"}
      </button>
      {error && <p style={{ color: "red" }}>{error}</p>}
    </form>
  );
}
